import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import Tutorial from "./Tutorial";
// import ReviewBallots from "./ReviewBallots";

const methods = ["plurality", "approval", "star", "rcv"];

const server = "https://ipo2020-dev-appservice.azurewebsites.net";
const spreadsheet = "1_CeovpvuXEseusS1sRAGL3nxUvbqydGKg-vmLlaRIpA";

function CastVote(method, voterId, vote, ipInfo) {
  const baseURL = `${server}/api/CastVote`;
  const apikey = "mS/BqUFdzqALY4EHLaqML1dys99r3eJde0Psq8jcbqmhFjGgsQllMQ==";
  const choices = vote.join(",");
  const row = `${voterId},${ipInfo},${choices}`;
  const url = `${baseURL}?code=${apikey}&election=${spreadsheet}&race=${method}&vote=${row}`;
  console.log(url);
  fetch(url);
}

export default function Demo({ path, race, candidates, history }) {
  const [index, setIndex] = useState(0);
  const [rankings, setRankings] = useState(Array(candidates.length).fill(0));
  const [results, setResults] = useState([[0], [0], [0], [0]]);
  const [voterId, setVoterId] = useState(null);
  const [ipInfo, setIpInfo] = useState(",,,");
  const [isNew, setIsNew] = useState(false);

  // For all methods, we require at least one choice, for RCV, we also require unique ranks
  const disableNext = (function() {
    const noChoices = !rankings.some(ranking => ranking > 0);
    if (noChoices || methods[index] !== "rcv") return noChoices;
    var occurrences = [];
    for (var i = 0, j = rankings.length; i < j; i++) {
      occurrences[rankings[i]] = (occurrences[rankings[i]] || 0) + 1;
    }
    return Math.max(occurrences.slice(1)) > 1;
  })();

  useEffect(() => {
    const getIpInfo =
      "https://api.ipregistry.co/?key=k7yxiv4b6a81xu&fields=ip,location.region.name,location.city,location.postal";
    fetch(getIpInfo)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const ipString = `${data.ip},${data.location.city},${
          data.location.region.name
        },${data.location.postal}`;
        setIpInfo(ipString);
      })
      .catch(err => console.log("ERROR", err));

    const id = window.localStorage.getItem("MetaVoteId");
    if (id) {
      if (id !== voterId) {
        setVoterId(id);
      }
    } else {
      setIsNew(true);
      const baseURL = `${server}/api/Register`;
      const apikey = "kfQeatR76anz4keA82kDwaxaX4emdEzUtERUQvBvL9b5KH5mYw9GdQ==";
      const url = `${baseURL}?code=${apikey}`;
      console.log("Register", url);
      fetch(url)
        .then(res => res.text())
        .then(res => {
          console.log(res);
          setVoterId(res);
          window.localStorage.setItem("MetaVoteId", res);
        });
    }
  }, [voterId]);

  const handleUpdate = (rankings, hasErrors) => {
    setRankings(rankings);
    setResults(prevState => {
      const newResults = [...prevState];
      newResults[index] = rankings;
      return newResults;
    });
  };

  const method = methods[index];

  // STAR rankings are odd because internally,
  const ApprovalToStar = rankings => {
    const newRankings = Array(rankings.length).fill(0);
    var i;
    for (i = 0; i < rankings.length; i++) {
      if (rankings[i] > 0) {
        newRankings[i] = 6;
      }
    }
    return newRankings;
  };
  const StarToRcv = rankings => {
    const valueUsed = (rankings, star) => rankings.some(x => x === star);
    const updateValue = (rankings, newRankings, star, rcv) => {
      var i;
      for (i = 0; i < rankings.length; i++) {
        if (rankings[i] === star) {
          newRankings[i] = rcv;
        }
      }
    };

    const newRankings = Array(rankings.length).fill(0);
    var star = 6;
    var rcv = 1;
    while (star > 0) {
      if (valueUsed(rankings, star)) {
        updateValue(rankings, newRankings, star, rcv);
        rcv += 1;
      }
      star -= 1;
    }

    return newRankings;
  };

  const Advance = () => {
    console.log("Advance", rankings, index);
    CastVote(methods[index], voterId, rankings, ipInfo);
    setResults(prev => {
      console.log("prev", prev);
      const newResults = [...prev];
      newResults[index] = rankings;
      return newResults;
    });

    var newRankings =
      index === 3
        ? Array(candidates.length).fill(0)
        : index === 2
        ? StarToRcv(rankings)
        : index === 1
        ? ApprovalToStar(rankings)
        : [...rankings];

    setIndex(index + 1);
    setRankings(newRankings);
    history.push(`${path}?step=${index + 2}`);
  };

  const Previous = () => {
    if (index > 0) {
      setIndex(index - 1);
      setRankings(results[index - 1]);
      history.push(`${path}?step=${index}`);
    }
  };

  if (index < 4) {
    return (
      <>
        <Tutorial
          key={method}
          method={method}
          race={race}
          candidates={candidates}
          defaultRankings={rankings}
          onUpdate={handleUpdate}
          next={Advance}
          prev={Previous}
          disableNext={disableNext}
          isNew={isNew}
        />
      </>
    );
    // } else if (index === 4) {
    //   return (
    //     <ReviewBallots
    //       candidates={candidates}
    //       results={results}
    //       next={Advance}
    //       prev={Previous}
    //     />
    //   );
  } else {
    return <Redirect to="/Subscribe" />;
  }
}
